export const SUBSCRIPTION_ITEM_EVENTS = {
  SUBSCRIBE: 'subscribe',
  CANCEL: 'cancel',
  RENEW: 'renew',
  CONTACT_US: 'contactUs'
}
